var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBulletin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11V13H22V11H18ZM16 18.61C16.96 19.32 18.21 20.26 19.2 21C19.6 20.47 20 19.93 20.4 19.4C19.41 18.66 18.16 17.72 17.2 17C16.8 17.54 16.4 18.08 16 18.61ZM20.4 4.6C20 4.07 19.6 3.53 19.2 3C18.21 3.74 16.96 4.68 16 5.4C16.4 5.93 16.8 6.47 17.2 7C18.16 6.28 19.41 5.35 20.4 4.6ZM4 8C2.9 8 2 8.9 2 10V14C2 15.1 2.9 16 4 16H5V20H7V16H9L15 19V5L9 8H4ZM10.03 9.71L13 8.53V15.47L9.55 14H4V10H9.55L10.03 9.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulletin);
export default __webpack_public_path__ + "static/media/icon-bulletin.ff32b15074342599e340ea90dc513f56.svg";
export { ForwardRef as ReactComponent };